 export const  vegpizza =  () =>  {

    return [{name:"",rprice:"R",mprice:"M",lprice:"L"},
    {name:"Margherita Pizza (Cheese and Sauce)",rprice:"89",mprice:"170",lprice:"250"},
    {name:"Veg Simple Pizza (Onion,Tomato, Cheese and Sauce)",rprice:"89",mprice:"170",lprice:"250"},
    {name:"Veg Crunchy Pizza (Onion,Capsicum, Cheese and Sauce)",rprice:"89",mprice:"170",lprice:"250"},
    {name:"Veg Spicy Pizza(Onion, Tomato, Green Chilli, Cheese and Sauce)",rprice:"99",mprice:"180",lprice:"260"},
    {name:"Sweet Corn Pizza(Sweet Corn, Onion, Tomato, Cheese and Sauce)",rprice:"105",mprice:"185",lprice:"270"},
    {name:"Pepper Paneer Pizza (Onion,Tomato, Capsicum,Paneer, Pepper,Cheese and Sauce)",rprice:"105",mprice:"185",lprice:"270"},
    {name:"Supreme Pizza (Onion,Tomato, Capsicum, Sweet corn, Mushroom, Cheese and Sauce)",rprice:"120",mprice:"210",lprice:"290"},
    {name:"BabyCorn Pizza (Onion,Tomato, Capsicum, Babycorn, Black Olives, jalapenos, Cheese and Sauce)",rprice:"129",mprice:"230",lprice:"310"}        
];

}


export const nonvegpizza = () => {

    return [{name:"",rprice:"R",mprice:"M",lprice:"L"},
    {name:"Cheesy Chicken Pizza (Chicken,Cheese, sauce)",rprice:"129",mprice:"230",lprice:"310"},
    {name:"Ferri Chicken Pizza (Onion,Green Chilli, Chicken,Cheese and Sauce)",rprice:"139",mprice:"250",lprice:"330"},
    {name:"Chicken Crunchy Pizza (Onion,Capsicum, Chicken,Cheese and sauce)",rprice:"145",mprice:"260",lprice:"340"},
    {name:"Pepper Chicken Masala Pizza (Onion,Capsicum, Chicken,Green Chilli, Coriander,pepper, Cheese and Sauce)",rprice:"149",mprice:"270",lprice:"350"},
    {name:"Supreme Chicken Pizza (Onion,Tomato, Capsicum,Chicken, Black Olives, jalapenos, Cheese and Sauce)",rprice:"159",mprice:"290",lprice:"370"},
    
];

}


export const wraps = () => {
    return [{name:"Veg Wrap",price:"70"},{name:"Paneer Wrap",price:"80"},{name:"Chicken Wrap",price:"90"}];
}

export const sandwiches = () =>{
    return [{name:"Veg Sandwich",price:"69"},
    {name:"Cheesy Veg Sandwich",price:"79"},
    {name:"Paneer Sandwich",price:"89"},
    {name:"Sweetcorn Sandwich",price:"89"},
    {name:"Cheesy Paneer Sandwich",price:"99"},
    {name:"Cheesy Sweetcorn Sandwich",price:"99"},
    {name:"Chicken Sandwich",price:"105"},
    {name:"Cheesy Chicken Sandwich",price:"115"},
];
}

export const burgers = () => {
    return [{name:"Veg Burger",price:"70"},
    {name:"Cheesy Veg Burger",price:"79"},
    {name:"Paneer Burger",price:"80"},
    
    {name:"Cheesy Paneer Burger",price:"89"},
    
    {name:"Chicken Burger",price:"90"},
    {name:"Cheesy Chicken Burger",price:"99"},
];
}

export const popcorns = () => {
    return [{name:"Chicken Popcorn",price:"90"},{name:"Peri Peri Chicken Popcorn",price:"99"}];
}

export const frenchfries =() => {
    return [{name:"Plain Fries",price:"69"},{name:"Masala Fries",price:"75"},{name:"Peri Peri Fries",price:"80"}];
}

export const biryani = () => {
    return [{name:"Chicken Biryani",price:"99"},{name:"Chicken65 Biryani",price:"99"},{name:"Lollipop Biryani",price:"135"}];
}

export const mocktails = () => {
    return [
        {name:"Blue Coracco" ,price:"80"},
        {name:"Watermelon" ,price:"60"},
        {name:"Grape" ,price:"65"},
        {name:"Pineapple with Coconut Water" ,price:"90"},
        {name:"Peach" ,price:"80"},
        {name:"Lichi" ,price:"65"},
        {name:"Lemon and Mint" ,price:"90"},
        {name:"Promegranate" ,price:"80"},
        {name:"Lemonade" ,price:"50"},
    ];
}

export const iceCreams = () => {
    return [
        {name:"Vanilla" ,price:"49"},
        {name:"Strawberry" ,price:"49"},
        {name:"Plain Pista" ,price:"59"},
        {name:"Mango" ,price:"79"},
        {name:"Chocolate" ,price:"79"},
        {name:"ButterScoth" ,price:"79"},
        {name:"Tutty Fruity" ,price:"79"},
        {name:"Black Current" ,price:"95"},
        {name:"Dry Fruit" ,price:"120"},
        {name:"Extra cherries" ,price:"10"},
        {name:"Extra Choco Chips",price:"20"}
    ];
}

export const friedItems = () => {
    return [
        {
            subtitle:"Lollipop",
            subitems:[
                {name:"4 Pieces",price:"100"},
                {name:"8 Pieces",price:"190"}
            ]
        },
        {
            subtitle:"Hot Wings",
            subitems:[
                {name:"3 Pieces",price:"60"},
                {name:"7 Pieces",price:"120"},
                {name:"15 Pieces",price:"250"}
            ]
        },
        {
            subtitle:"Strips",
            subitems:[
                {name:"3 Pieces",price:"90"},
                {name:"7 Pieces",price:"180"},
                {name:"15 Pieces",price:"350"}
            ]
        },
        {
            subtitle:"Bucket Chicken",
            subitems:[
                {name:"2 Pieces",price:"100"},
                {name:"4 Pieces",price:"190"},
                {name:"8 Pieces + 250ml soft drink",price:"380"},
                {name:"12 Pieces + 1 liter soft drink",price:"580"}
            ]
        }
    ];
}

export const combos = () => {
    return [
        {
            subtitle:"Arrow Hub Meal Pack",
            subitems:[
                {name:"7 Wings + 250ml Soft drink + french fries",price:"200"},
                {name:"Veg / Chicken Burger + 1 pc Bucket Chicken + 250ml Soft drink + French fries",price:"210"}
            ]
        },
        {
            subtitle:"Arrow Hub Couple Pack",
            subitems:[
                {name:"2 pc Bucket Chicken + 2 french fries +2 pc strips + 2 soft drinks(250ml)",price:"315"},
               
            ]
        },
        {
            subtitle:"Arrow Hub Fried Chicken Jumbo",
            subitems:[
                {name:"10 pc Bucket Chicken + 6 pc wings + 3pc strips + 1 french fries + 1 popcorn +1 liter soft drink",price:"850"},
               
            ]
        },
        {
            subtitle:"Arrow Hub Pizza Combo",
            subitems:[
                {name:"Veg Pizza + Veg Burger + Veg Sandwich + Lemonade",price:"250"},
                {name:"Chicken Pizza + Chicken Burger + Chicken Sandwich + Lemonade",price:"350"}
            ]
        }


    ];
}

